<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>替换列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column prop="source" label="原字符（被替换词组，可多组，逗号分隔）" min-width="280">
      </el-table-column>
      <el-table-column prop="target" label="替换后的词组" min-width="240">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="180">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="36%" @click="closeDialog">
      <el-form label-width="180px" :model="editForm" ref="editForm">
        <el-form-item label="原字符">
          <el-input size="small" v-model="editForm.source" auto-complete="off"
            placeholder="被替换的词组；多组用中文逗号“，”分隔，如：无花水果，无花瓜"></el-input>
        </el-form-item>
        <el-form-item label="替换后的词组">
          <el-input size="small" v-model="editForm.target" auto-complete="off"
            placeholder="替换后的词组，如：无花果"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title"
          @click="submitForm()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { campList, campListDel, campListSave, campListUp } from '../../api/campsMG17'
export default {
  data() {
    return {
      loading: false,
      editFormVisible: false,
      title: '添加',
      isEdit: false, // true=编辑已有记录，false=新增
      oldSource: '', // 编辑时保存原记录的原字符
      oldTarget: '', // 编辑时保存原记录的替换后词组
      editForm: {
        source: '',
        target: ''
      },
      formInline: {
        token: localStorage.getItem('logintoken')
      },
      listData: []
    }
  },
  created() {
    this.getdata()
  },
  methods: {
    // 获取列表
    getdata() {
      this.loading = true
      campList(this.formInline)
        .then(res => {
          this.loading = false
          if (res.data.code != 0) {
            this.$message({ type: 'info', message: res.msg })
          } else {
            this.listData = res.data.data.list
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('列表加载失败，请稍后再试！')
        })
    },
    // 显示新增/编辑界面
    handleEdit(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != null) {
        this.title = '编辑'
        this.isEdit = true
        this.oldSource = row.source
        this.oldTarget = row.target
        this.editForm.source = row.source
        this.editForm.target = row.target
      } else {
        this.title = '添加'
        this.isEdit = false
        this.oldSource = ''
        this.oldTarget = ''
        this.editForm.source = ''
        this.editForm.target = ''
      }
    },
    // 保存（新增或编辑）
    submitForm() {
      if (!this.editForm.source || !this.editForm.source.trim()) {
        this.$message({ type: 'warning', message: '请填写原字符（被替换词组）' })
        return
      }
      if (!this.editForm.target || !this.editForm.target.trim()) {
        this.$message({ type: 'warning', message: '请填写替换后的词组' })
        return
      }
      const params = { source: this.editForm.source.trim(), target: this.editForm.target.trim() }
      const req = this.isEdit
        ? campListUp(Object.assign({ oldSource: this.oldSource, oldTarget: this.oldTarget }, params))
        : campListSave(params)
      req
        .then(res => {
          if (res.code == 0) {
            this.editFormVisible = false
            this.loading = false
            this.getdata()
            this.$message({ type: 'success', message: '保存成功！' })
          } else {
            this.$message({ type: 'info', message: res.msg })
          }
        })
        .catch(err => {
          this.editFormVisible = false
          this.loading = false
          this.$message.error('保存失败，请稍后再试！')
        })
    },
    // 删除
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          campListDel({ source: row.source, target: row.target })
            .then(res => {
              if (res.code == 0) {
                this.$message({ type: 'success', message: '已删除!' })
                this.getdata()
              } else {
                this.$message({ type: 'info', message: res.msg })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({ type: 'info', message: '已取消删除' })
        })
    },
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/camp/camps17.vue